import request from '@/utils/request'

export function showplatform() {
  return request({
    url: 'api/robot/showplatform',
    method: 'get'
  })
}

export function description(lang) {
  return request({
    url: 'api/robot/description',
    method: 'get',
    params: {
      lang
    }
  })
}

export function getRobotNameList(params) {
  return request.get('/api/robot/showlist', { params: params })
}
// 机器人列表 params: {page,limit}
export function getRobotList(params) {
  return request.get('/api/robot/', { params: params })
}
// 机器人话术列表 params: {page,limit,robot_id}
export function getScriptList(params) {
  return request.get('/api/script/', { params: params })
}
// 新增话术 params:{script,variable,robot_id}
export function postAddScript(params) {
  return request.post(`/api/script/`, params)
}
// 删除话术 params:{id}
export function deleteScript(params) {
  return request.delete(`/api/script/${params.id}/`)
}
// 试听 params:{var:[{borrower_name}],script_id}
export function postScriptGenTts(params) {
  return request.post(`/api/script/gen_tts/`, params)
}
// 当前生效 params:{robot_id}
export function postScriptEffect(params) {
  return request.get(`/api/script/effect_script/`, { params })
}
// 变量列表
export function postScriptVariable(params) {
  return request.get(`/api/script/variable/`, { params })
}
// 修改话术
export function putUpdateScript({ id, script }) {
  return request.put(`/api/script/${id}/`, { script })
}
// 生效应用话术
export function postApplyScript(params) {
  return request.post(`/api/script/${params.id}/effect/`)
}
// 历史
export function getActionHistory(params) {
  return request.get(`/api/script/history/`, { params })
}
export function postUpdateRobotRemark({ id, remark }) {
  return request.patch(`/api/robot/${id}/`, { remark })
}
// 下载记录
export function downLoadRobotList(params) {
  return request.post('/api/robot/download/', params, { responseType: 'blob' })
}

export function robotViewList(params) {
  return request.get('/api/robot/info/', { params })
}
export function addGroup(params) {
  return request.post('/api/label_group/', params)
}
export function editGroup(params, id) {
  return request.put(`/api/label_group/${id}/`, params)
}
export function groupList(params) {
  return request.get('/api/label_group/', { params })
}
export function cancelGroup(params) {
  return request.delete(`/api/label_group/${params}/`)
}



// WEBPACK FOOTER //
// ./src/api/Robot.js